// @flow

import type {OrderAnonymousReplacementCardItem} from './order-anonymous-replacement-card-item'
import type {OrderPersonalReplacementCardItem} from './order-personal-replacement-card-item'

export type OrderReplacementCardRequest = {
  orderReplacementCardItems: Array<OrderAnonymousReplacementCardItem | OrderPersonalReplacementCardItem>
}

const buildOrderReplacementCardRequest = (
  orderReplacementCardItems: Array<OrderAnonymousReplacementCardItem | OrderPersonalReplacementCardItem>
): OrderReplacementCardRequest => {
  return {
    orderReplacementCardItems
  }
}

export {
  buildOrderReplacementCardRequest
}



// WEBPACK FOOTER //
// ./src/types/order-replacement-card-request.js